// Footer Component for Gift-Wish - Premium Elegant Night
import { Gift } from "lucide-react";
import { useLanguage } from "@/contexts";
import FooterInstallButton from "@/components/FooterInstallButton";

export const Footer = () => {
  const { t, language } = useLanguage();
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="py-8 px-6 border-t border-border/30 bg-surface/50 backdrop-blur-sm mt-auto">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-2.5">
          <div className="w-8 h-8 bg-gradient-to-br from-primary to-primary/70 rounded-lg flex items-center justify-center">
            <Gift className="w-4 h-4 text-white" />
          </div>
          <span className="font-heading font-semibold tracking-tight">{t("app_name")}</span>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6 text-sm text-muted-foreground">
          <a href="/privacy" className="hover:text-primary transition-colors">{t("privacy_policy") || "Privacy"}</a>
          <a href="/terms" className="hover:text-primary transition-colors">{t("terms_of_service") || "Terms"}</a>
          <a href="/contact" className="hover:text-primary transition-colors">{t("contact") || "Contact"}</a>
          <FooterInstallButton language={language} />
        </div>
        <p className="text-sm text-muted-foreground">
          © {currentYear} {t("app_name")}. {t("all_rights")}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
